import { useLanguage } from '../context/LanguageContext';
import { Heart } from 'lucide-react';

export default function PetTypeHeroBanner() {
  const { isRomanian } = useLanguage();

  return (
    <div 
      className="bg-gradient-to-r from-brand-orange via-[#ff8855] to-brand-orange py-6 overflow-hidden relative"
      data-testid="pet-type-hero-banner"
    >
      {/* Animated sparkles */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-2 left-[10%] w-2 h-2 bg-white/40 rounded-full animate-ping" style={{animationDelay: '0s', animationDuration: '2s'}}></div>
        <div className="absolute top-4 left-[30%] w-1.5 h-1.5 bg-white/30 rounded-full animate-ping" style={{animationDelay: '0.5s', animationDuration: '2.5s'}}></div>
        <div className="absolute bottom-2 left-[50%] w-2 h-2 bg-white/40 rounded-full animate-ping" style={{animationDelay: '1s', animationDuration: '2s'}}></div>
        <div className="absolute top-3 left-[70%] w-1.5 h-1.5 bg-white/30 rounded-full animate-ping" style={{animationDelay: '1.5s', animationDuration: '2.5s'}}></div>
        <div className="absolute bottom-3 left-[90%] w-2 h-2 bg-white/40 rounded-full animate-ping" style={{animationDelay: '0.3s', animationDuration: '2s'}}></div>
      </div>
      
      <div className="section-container text-center relative z-10">
        <p className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white tracking-wider uppercase flex items-center justify-center gap-3 flex-wrap">
          <Heart className="w-6 h-6 md:w-8 md:h-8 text-white fill-white/30 animate-pulse" />
          {isRomanian 
            ? 'CUTII SURPRIZĂ PENTRU BLĂNOȘII TĂI'
            : 'SURPRISE BOXES FOR YOUR FURRY BESTIES'}
          <Heart className="w-6 h-6 md:w-8 md:h-8 text-white fill-white/30 animate-pulse" />
        </p>
      </div>
    </div>
  );
}
